
export class HTMLTableCreator {
    public Table:HTMLTableElement;
    private tHead:HTMLElement;
    private tBody:HTMLElement;
    private tFoot:HTMLElement;
    private lastSectionCreated:HTMLElement;
    private lastRow:HTMLTableRowElement;
    constructor(classes:string=''){
        this.Table=document.createElement('table');
        this.Table.className=classes;
    }

    CreateTHead(classes:string='')
    {
        if(this.tHead==null) {
            this.tHead = document.createElement('thead');
            this.tHead.className=classes;
            this.Table.appendChild(this.tHead);
            this.lastSectionCreated=this.tHead;
        }
    }

    CreateTBody(classes:string='')
    {
        if(this.tBody==null) {
            this.tBody = document.createElement('tbody');
            this.tBody.className=classes;
            this.Table.appendChild(this.tBody);
            this.lastSectionCreated=this.tBody;
        }
    }

    CreateTFoot(classes:string='')
    {
        if(this.tFoot==null) {
            this.tFoot = document.createElement('tfoot');
            this.tFoot.className=classes;
            this.Table.appendChild(this.tFoot);
            this.lastSectionCreated=this.tFoot;
        }
    }

    CreateRow(classes:string=''){
        if(this.lastSectionCreated==null)
            throw new Error('No tbody or thead was created yet');

        this.lastRow=document.createElement('tr');
        this.lastRow.className=classes;
        this.lastSectionCreated.appendChild(this.lastRow);
    }



    CreateTextColumn(element,classes:string='',columnType:'th'|'td'='td')
    {

        let column=document.createElement(columnType);
        column.className=classes;
        this.lastRow.appendChild(column);

        let p=document.createElement('p');
        p.innerText=element;
        column.appendChild(p);
    }

    CreateRawColumn(element,classes:string='',columnType:'th'|'td'='td')
    {

        let column=document.createElement(columnType);
        column.className=classes;
        this.lastRow.appendChild(column);
        column.appendChild(element);
    }

}